export default "__VITE_ASSET__BXVoscpo__"